export default {
    view: "Contact"
};